import React, { useEffect, useRef } from "react";

// Derive the widget CDN base from the API URL: replace /api/v1 suffix with /widget/v1.
// Falls back to the tst URL so local dev without .env still works.
const API_URL =
  process.env.REVIEWS_API_URL ||
  "https://api.tst.carreira.cloud/reviews/api/v1";
const WIDGET_BASE = API_URL.replace(/\/api\/v1$/, "/widget/v1");

function loadWidgetAssets(): Promise<void> {
  return new Promise((resolve) => {
    const cssId = "reviews-widget-css";
    const jsId = "reviews-widget-js";

    if (!document.getElementById(cssId)) {
      const link = document.createElement("link");
      link.id = cssId;
      link.rel = "stylesheet";
      link.href = `${WIDGET_BASE}/reviews-widget.css`;
      document.head.appendChild(link);
    }

    if (document.getElementById(jsId)) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.id = jsId;
    script.src = `${WIDGET_BASE}/reviews-widget.js`;
    script.onload = () => resolve();
    document.head.appendChild(script);
  });
}

interface ReviewsWidgetProps {
  entityId: string;
  entityType: string;
  customerName?: string;
  customerEmail?: string;
  authToken?: string;
  locale?: string;
}

const ReviewsWidget: React.FC<ReviewsWidgetProps> = ({
  entityId,
  entityType,
  customerName,
  customerEmail,
  authToken,
  locale = "pt",
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const apiGwKey = process.env.REVIEWS_API_GW_KEY || "";

  useEffect(() => {
    loadWidgetAssets().then(() => {
      if (containerRef.current && window.ReviewsWidget) {
        window.ReviewsWidget.init({
          apiKey: apiGwKey,
          apiUrl: API_URL,
          container: containerRef.current,
          entityId,
          entityType,
          customerName,
          customerEmail,
          authToken,
          locale,
          allowSubmit: true,
          showStats: true,
        });
      }
    });
  }, [entityId, entityType, customerName, customerEmail, authToken, locale]);

  return <div ref={containerRef} id="reviews-widget" className="mt-8" />;
};

export default ReviewsWidget;
